import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state?: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const expectedRoles = (route.data['roles'] as Array<string>) ?? [];
  const userRole = authService.currentUser()?.role;
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    router.navigate(['/auth/login']);
    return false;
  }

  const isSuperAdmin = userRole === 'super_admin';
  const matchesRole = isSuperAdmin || expectedRoles.includes(userRole || '');

  if (matchesRole) {
    return true;
  }

  // URL réellement demandée : celle de la navigation en cours (avant les
  // redirections de routes comme /audit-logs → /integrations-hub), puis
  // l'URL résolue, et seulement en dernier recours le motif de la route.
  const requested =
    router.currentNavigation?.()?.initialUrl?.toString() || state?.url || route.routeConfig?.path;
  router.navigate(['/access-denied'], {
    queryParams: { from: requested },
  });
  return false;
};
